<template>
  <div class="white z-depth-1" style="padding-left: 11px; padding-right: 11px;">
    <div class="row">
      <div class="left" style="padding-top: 10px;">
        <span class="title" style="padding-left: 11px;">{{ this.$t('analysis.heatmap') }}</span>
      </div>
    </div>
    <h6 v-if="railObject !== null">{{ railObject.ComplexName + ' ' + railObject.Name}}</h6>
    <!-- <img v-if="image !== null"
         :src="'data:image/tiff;base64,' + image"
         :alt="railObject.ComplexName + ' ' + railObject.Name"
         :title="railObject.ComplexName + ' ' + railObject.Name"
         class="heatmap"
    /> -->
    <div class="row">
      <div class="input-field col s2">
        <!-- <input id="s-dir" type="text" v-model="healthScores.direction"><label for="s-dir">Direction</label> -->
        <select v-model="linear" class="browser-default">
          <option v-for="option in linearOptions" :value="option.value" :key="option.value">
            {{ option.name }}
          </option>
        </select>
      </div>
    </div>
    <div style="padding-bottom: 5px;">
      <button v-if="downloadProgress===100 && !downloadClicked" href="#!" :disabled="!isChild"  @click.prevent="download()" class="btn blue">{{ $t('views.switch.tabs.download') }}</button>
      <div v-if="!isChild" class="h5">{{ $t('views.analysis.heatmap.selectswitch') }}</div>
      <p v-if="downloadProgress===100 && downloadClicked">{{ $t('views.analysis.heatmap.preparingdownload') }}</p>
      <p v-if="downloadProgress<100">{{ $t('views.analysis.heatmap.downloading') }} {{downloadProgress}}%</p>
      <div v-if="downloadMessage !== ''" class="card-panel red lighten-4"><h6>{{downloadMessage}}</h6></div>
    </div>
  </div>
</template>

<script>
import Vue from 'vue'
import moment from 'moment'
import HeatmapService from '@/services/HeatmapService'

export default {
  name: 'HeatmapAnalysis',
  components: {},
  props: {
    railObject: {
      required: true
    },
    timeSelection: {
      required: true
    },
    activeid: {
      type: Number,
      default: null
    }
  },
  data () {
    return {
      downloadProgress: 100,
      downloadMessage: '',
      downloadClicked: false,
      linearOptions: [ {name: 'Linear', value: 1}, {name: 'Non-linear', value: 0} ],
      linear: 1
    }
  },
  methods: {
    download () {
      var m = moment
      var downloadHeatmap = async (id, progressCallback) => {
        let result = await HeatmapService.GetHeatmap(id, this.linear, m(this.timeSelection.start).toDate(), m(this.timeSelection.end).toDate(), progressCallback)
        return result
      }
      this.downloadMessage = ''
      this.downloadClicked = true
      var self = this
      downloadHeatmap(this.railObject.RailObjectId, function (progress) {
        Vue.set(self, 'downloadProgress', progress)
        // this.downloadProgress = progress
      }
      )
        .then(response => {
          let url = window.URL.createObjectURL(new Blob([response.data]))
          let link = document.createElement('a')
          link.href = url
          link.setAttribute('download', 'heatmap ' + this.railObject.Name + ' ' + moment().format('DD-MM-YYYY HH:mm:ss') + '.jpg')
          document.body.appendChild(link)
          link.click()
        })
        .catch(async e => {
          if (e.response && e.response.data.size > 0) {
            const message = await e.response.data.text()
            this.downloadMessage = message
          } else {
            this.downloadMessage = 'Something went wrong. Could not heatmap create heatmap'
          }
          // Vue.set(self.downloadProgress, md5Checksum, 'failed')
          // setTimeout(() => {
          //   Vue.set(self.downloadProgress, md5Checksum, 100)
          // }, 2000)
        }).finally(f => {
          this.downloadProgress = 100
          this.downloadClicked = false
        })
    }
  },
  computed: {
    isChild () {
      return this.railObject.ParentRailObjectId // && this.railObject.PossObjectCodeId === 3
    }
  }
}
</script>

<style scoped>
  .heatmap {
  }

  .title {
    font-family: Roboto;
    font-style: normal;
    font-weight: 500;
    font-size: 20px;
    line-height: 23px !important;
    color: rgba(0, 0, 0, 0.87);
  }
</style>



// WEBPACK FOOTER //
// src/components/switch/analysis/HeatmapAnalysis.vue